<template>
    <div class="custom-alarm-field-content">
        <span class="field-label">{{$props.label}}</span>

        <div class="field-content">

            <draggable v-model="parts" v-bind="dragOptions" @end="handleChange" style="width: fit-content; display: flex;">
                <template v-for="(part, index) in parts">
                    <div :class="`part-container ${part.type} ${selectedPartIndex == index ? 'selected' : ''}`" @click="selectedPartIndex = index">
                        <template v-if="part.type == 'text'">
                            <v-text-field class="part" outlined dense height="30" v-model="part.value" :style="{width: calcTextFieldWidth(part.value)}" autofocus />
                        </template>
                        <template v-else-if="part.type == 'regex_variable'">
                            <span class="part regex_variable">{{part.value}}</span>
                        </template>
                    </div>
                </template>
            </draggable>

            <div>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="add-button mr-1" color="#c42111" width="40" min-width="40" v-bind="attrs" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="addPart('text')">
                            <span>Text</span>
                        </v-list-item>
                        <template v-for="(commonValue, idx) in $props.groupingCriteriaList">
                            <v-list-item @click="addPart('regex_variable', idx)">
                                <span>{{`common_value_${idx + 1}`}}</span>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-menu>

                <v-btn @click="deleteSelectedPart" class="delete-button" color="#c42111" width="40" min-width="40" v-if="parts.length"><v-icon>mdi-delete-forever</v-icon></v-btn>
            </div>

        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    name: 'CustomAlarmField',
    props: ['label', 'groupingCriteriaList', 'value'],
    components: {
        draggable
    },
    data: () => ({
        parts: [],
        selectedPartIndex: null,
        dragOptions: {
            animation: 200,
            group: "office_parts",
            disabled: false,
            ghostClass: "ghost"
        }
    }),

    computed: {
    },

    methods: {
        addPart: function(type, index) {
            if(type == 'text') {
                this.parts.push({type: type, value: ''});
            }
            else if (type == 'regex_variable') {
                this.parts.push({type: type, value: `<common_value_${index + 1}>`});
            }
        },

        calcTextFieldWidth: function(textVal) {
            let width = textVal ? (textVal.length * 9.6) + 5 : 0;
            return `${width}px`;
        },

        handleChange: function() {
            console.log("dragged changed!");
        },

        deleteSelectedPart: function() {
            if(this.selectedPartIndex != null) {
                this.parts.splice(this.selectedPartIndex, 1);
                this.selectedPartIndex = null;
            }
        }
    },

    watch: {
        parts: {
            handler(newVal, oldVal) {
                let value = "";
                for(let part of newVal) {
                    value += (part.type == 'text' ? part.value : part.value);
                }
                this.$emit('input', value);
            },
            deep: true
        },

        value: {
            handler(newVal, oldVal) {
                if(newVal === null) {
                    // Reset parts
                    this.parts = [];
                }
            },
            deep: true
        }
    },

    created() {
        let delimiter = /(<common_value_\d*>)/;
        if(!this.$props.value) {
            return;
        }
        let parts = this.$props.value.split(delimiter);
        parts = parts.filter(p => p); // Remove the empty ones
        for(let part of parts) {
            this.parts.push({type: part.includes('<common_value_') ? 'regex_variable' : 'text', value: part});
        }
    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .custom-alarm-field-content {
        width: 100%;
        overflow-x: auto;
        height: 100px;
        margin-bottom: -25px;
    }

    .field-content {
        display: flex;
        width: fit-content;
        max-height: 100px;
    }

    .part-container {
        position: relative;
        display: inline-block;
        height: 40px;
        min-width: 50px;
        margin-right: 5px;
        cursor: grab;
        border: #000000 solid 1px;
        border-radius: 4px;
        padding: 3px 3px 3px 3px;
        float: left;
        font-family: monospace;
    }
    .part-container.text {
        background-color: #2196F3;
    }
    .part-container.regex_variable {
        background-color: #9E9D24;
    }
    .part-container.selected {
        border: yellow solid 2px;
    }

    .part-container .part {
        height: 30px !important;
        min-height: 30px !important;
    }

    .part-container .part.regex_variable {
        font-weight: bold;
    }


    .add-button {
        display: inline-block;
    }
</style>

<style>

    .custom-alarm-field-content .part-container.text .part .v-input__slot {
        height: 30px !important;
        min-height: 30px !important;
        padding: 0px;
        min-width: 40px;
    }

</style>
